import React from 'react'

const BlankPage = () => {
  return (
    <div>BlankPage</div>
  )
}

export default BlankPage